// Wrapper that exposes the legacy `{id,name}` province + `LocationSuggestion` shape
// expected by CompactSearchBar/Explorar, backed by the canonical data in `@/lib/angolaLocations`.
import { PROVINCES, CITIES_BY_PROVINCE } from "@/lib/angolaLocations";

export type Province = { id: string; name: string };

const slug = (s: string) =>
  s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const ANGOLA_PROVINCES: Province[] = [
  { id: "all", name: "Todas as Províncias" },
  ...PROVINCES.map((name) => ({ id: slug(name), name })),
];

export { CITIES_BY_PROVINCE };

export type LocationSuggestion = {
  id: string;
  name: string;
  fullName: string;
  type: "province" | "city";
  province: string;
};

const normalize = (s: string) =>
  s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim();

export function searchLocations(query: string, limit = 8): LocationSuggestion[] {
  const q = normalize(query || "");
  const out: LocationSuggestion[] = [];

  for (const province of PROVINCES) {
    if (!q || normalize(province).includes(q)) {
      out.push({
        id: `prov-${slug(province)}`,
        name: province,
        fullName: province,
        type: "province",
        province,
      });
      if (out.length >= limit) return out;
    }
  }

  for (const [province, cities] of Object.entries(CITIES_BY_PROVINCE)) {
    for (const city of cities) {
      if (!q || normalize(city).includes(q) || normalize(province).includes(q)) {
        out.push({
          id: `city-${slug(province)}-${slug(city)}`,
          name: city,
          fullName: `${city}, ${province}`,
          type: "city",
          province,
        });
        if (out.length >= limit) return out;
      }
    }
  }

  return out;
}
